<template>
  <div class="custom-status-stepper col-md-12">
    <div class="top" v-if="isReady">
      <div 
        v-for="(item, index) in tabs"
        :key="index" 
        :class="{
          'step-header': true, 
          'active': index <= currentPosition,
          'line-active': index < currentPosition
          }"
      >
        <div :class="{'header-indicator': index < tabs.length -1}">
          <div :id="formattedID(item, index)" class="step-header-content">
            <feather v-if="index == currentPosition" :type="applicant.rejected ? 'x' : 'flag'" class="icon-xs" />

            <div v-else-if="!item.isActive" :class="{'icon-dot': tabs.length != index + 1}" />

            <i v-else 
              :class="`${!Object.entries(item.content).length ? 'uil-minus' : 'uil-check '} mt-2`" 
              :style="`${!Object.entries(item.content).length ? 'font-size: 16px; margin-bottom: 2px;' : 'font-size: 22px;'}`"
            />

            <b-tooltip
              v-if="item.isActive"
              :target="formattedID(item, index)"
              placement="bottom"
            >{{ formattedNote(item.note, index == currentPosition) }}</b-tooltip>
          </div>

          <div class="step-header-line" v-if="index < tabs.length - 1" />
        </div>
        <div class="row" :class="{'step-body-content': true, }">
          <div class="col-md-12">{{item.title}}</div>
          <div 
            v-if="Object.entries(item.content).length && item.isActive" 
            class="col-md-12" style="color: #888888;"
          >{{item.content.updated_at}}</div>
          <div v-if="Object.entries(item.content).length && item.isActive" class="col-md-12">
            <span class="font-weight-bold" style="color: #888888;">Updated by: </span> 
            {{item.content.updated_by}}
          </div>
        </div>
      </div>
    </div>
    <Loading v-else customClass="true" :loading="true" title="Loading..."/>
  </div>
</template>

<script>
import moment from 'moment'
import 'moment-timezone';
import Loading from '@components/LoadingSpinner'
import Dropdown from '@src/static/dropdown'
export default {
  name: 'Stepper',
  components: { Loading },
  props: {
    applicant:{
      type:Object,
      default: function () {
        return {}
      }
    }
  },
  data () {
    return {
      startSteps: [
        { title: 'Shortlisted', content: {}, note: '', isActive: false },
        { title: 'Submitted', content: {}, note: '', isActive: false },
        { title: '1st Interview', content: {}, note: '', isActive: false },
        { title: '2nd Interview', content: {}, note: '', isActive: false },
      ],
      endSteps: [
        { title: 'Offered', content: {}, note: '', isActive: false },
        { title: 'Placed', content: {}, note: '', isActive: false },
      ],
      addInterview: [],
      tabs: [],
      currentPosition: 0,
      transitionType: 'slide',
      isReady: false,
      rejected_note: ''
    }
  },
  methods: {
    formattedID(tab, idx) {
      let id = tab.text.replaceAll(' ', '')
      return id + idx.toString() + this.applicant._id
    },
    formatdate: function (value) {
      if (!value) return ''

      let format = 'YYYY/MM/DD hh:mm:ss A';
      return moment(value).tz('Japan').format(format)
    },
    formatedStep(step, key, isActive = false){
      let obj = {...step}

      obj.isActive = isActive
      let activities = this.applicant.last_activities.filter(
        item => item._id == key && this.formattedChar(item.title) == this.formattedChar(obj.text)
      )

      if(activities.length) {
        let content = activities[0] || {}
        let updated_by = content.updatedBy || {}

        obj.content = {
          updated_at: this.formatdate(content.date_created),
          updated_by: `${updated_by.first_name} ${updated_by.last_name}` 
        }

        obj.note = content.description
      }
      obj.title = obj.text

      return { ...obj }
    },
    formattedNote(note, isfinal = false) {
      if(isfinal && this.rejected_note) {
        return this.rejected_note
      } else if(!note && !isfinal) {
        return 'Skipped'
      } else {
        return note || 'No note added'
      }
    },
    formattedChar(val) {
      return val.toLowerCase().replace(' ', '-')
    },
    fetchAdditionalInterview(id) {
      let param = {}
      param.id = id

       return this.$store.dispatch('application/getApplication', param)
      .then(res => {
        if (res && res.data) {
          let { activities } = res.data
          let addInterview = activities.filter( status => status.add_interview == true )

          if(addInterview.length) {
            for(let key in addInterview) {
              let obj = addInterview[key]

              let data = {
                title: obj.title,
                content: {
                  updated_at: this.formatdate(obj.date_created),
                  updated_by: obj.recruiter_id.full_name 
                },
                note: obj.description,
                isActive: true
              }

              this.tabs.push({ ...data })
            }

            this.addLastSteps(addInterview.length)
          }
        }
      })
    },
    addLastSteps(additionalSteps = 0) {
      let startArr = [...this.startSteps]
      let endArr = [...this.endSteps]
      for(let key in endArr) {
        let endObj = endArr[key]
        let status = parseInt(key) + startArr.length
        let endStep = this.formatedStep(endObj, status + 2, (status + additionalSteps) <= this.currentPosition)
  
        this.tabs.push({ ...endStep })

        if(endArr.length == parseInt(key) + 1) {
          this.isReady = true
        }
      }
    }
  },
  mounted() {
    let applicant = {...this.applicant}
    console.log('statat', applicant)
    let { status_type,  add_interview, add_interview_step, last_activities, rejected } = applicant

    let add_step = status_type > 4 ? add_interview_step - 1 - 1 : 0
    this.currentPosition = status_type - 1 + add_step

    // let startArr = [...this.startSteps]
    let startArr = [...Dropdown.statusList]
    for(let key in startArr) {
      let startObj = startArr[key]
      let startStep = this.formatedStep(startObj, parseInt(key) + 1, key <= this.currentPosition)

      this.tabs.push({ ...startStep })

      if(startArr.length == parseInt(key) + 1) {
        this.isReady = true
      }
    }

    //for additional inteview step
    if((add_interview || add_interview_step > 1) && status_type > 4) {
      // this.fetchAdditionalInterview(applicant._id)
    } else {
      // this.addLastSteps()
    }

    if(rejected) {
      let data = last_activities.filter(
        item => item._id == true && this.formattedChar(item.title) == this.formattedChar('rejected')
      ).map(ele=>ele.description)
  
      this.rejected_note = data[0]
    }
  }
};
</script>

<style>
.top{
    display: flex;
    flex-direction: row;
    /* overflow-x: auto; */
    padding: 1px;
    width: 100%;
    justify-content: left;
}
.step-header{
    display: flex;
    flex-direction: column;
}
.header-indicator{
    display: flex;
    flex-direction: row;
    align-items: center;
    justify-content: center;
}

.step-header-line{
    display: inline-flex;
    width: 150px;
    height: 3px;
    background-color: #9CA3AF;
}
.step-header-content{
    display: inline-flex;
    width: 32px;
    height: 32px;
    border-radius: 50%;
    background-color: rgb(255, 255, 255);
    color: #D1D5DB;
    align-items: center;
    justify-content: center;
    cursor: pointer;
    border: 2px solid #9CA3AF;
}

.step-header.active .step-header-content,
.step-header.line-active .step-header-line {
    background-color: rgb(0, 0, 0);
    border: 2px solid #000000;
    color: white;
}

.step-header-content:has(.uil-minus) {
  background-color: #D1D5DB !important;
  color: #ffffff !important;
  border: 2px solid #D1D5DB !important;
}

.step-header-content:has(.feather-x) {
  background-color: #ff5c75 !important;
  color: #ffffff !important;
  border: 2px solid #ff5c75 !important;
}

.step-body-content{
    display: inline-flex;
    text-transform: capitalize;
    width: 165px;
    position: relative;
    font-size: 12px;
    margin-top: 4px;
    color: #333333;
}


.steps-item{
    min-width: 100%;
}
.custom-status-stepper{
    padding: 20px;
    display: flex;
    flex-direction: column;
    align-items: center;
}

.icon-dot {
  /* position: absolute; */
  width: 10px;
  height: 10px;
  top: 12px !important  ;
  background-color: #D1D5DB;
  border-radius: 50%;
  display: inline-block !important;
}

@media (max-width: 1707px) {
  .step-body-content {
    width: 165px;
    font-size: 12px;
  }
  .step-header-line {
    width: 120px;
  }
}

@media (max-width: 1397px) {
  .step-body-content {
    width: 145px;
    font-size: 10px;
  }
  .step-header-line {
    width: 100px;
  }
}
</style>